import { createPlugin } from '@lumapps/wrex/slate/plugin';

import { DragAndDropHOC, type WithDragAndDropOptions } from '../components/DragAndDropHOC';

export const withDnD = (options?: WithDragAndDropOptions) =>
    createPlugin({
        createPluginEditor: () => ({}),
        editableWrapper: DragAndDropHOC(options),
    });
